import React, { useState, useEffect } from "react";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { toast } from "react-toastify";
import { MdDelete } from 'react-icons/md';
import { statusActiveFormatteruser } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName, videodownloadXLSX, videodownloadPDF } from "../../../components/CommonMethod/CommonMethods";
import { BiRecycle } from "react-icons/bi";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LiaUndoAltSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import moment from 'moment';

function AllPartners() { // Renamed component
  const BaseUrl = process.env.REACT_APP_Baseurl
  // Updated to use correct partner API routes from adminRoutes.js
  const listApi = `${BaseUrl}/admin/partner/index`
  const multiDeleteApi = `${BaseUrl}/admin/partner/multi-delete`
  const recycleApi = `${BaseUrl}/admin/partner/recylePartners` // Note: recylePartners (typo in route)
  const restoreApi = `${BaseUrl}/admin/partner/restore`
  const singleDeleteApi = `${BaseUrl}/admin/partner/delete`
  const { fetchRequest } = useMyContext()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [Permanent, setPermanent] = useState(0);
  const [type, setType] = useState(null)
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState('')
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [activeId, setActiveId] = useState(null)
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })
  // Updated analytics for partner data
  const [analytics, setAnalytics] = useState({
    totalPartners: 0,
    activePartners: 0,
    pendingPartners: 0,
    totalCommission: 0
  })

  const fetchData = async () => {
    setLoading(true)
    // Determine which API to call based on draft state
    const apiUrl = draft === 1 ? recycleApi : listApi;

    await fetchRequest({
      method: 'GET',
      url: apiUrl,
      params: draft === 0 ? {
        page,
        limit: formData?.title ? 9999 : limit, // Fetch all for searching
        search: formData?.title,
      } : {}, // No params needed for recycle API
      data: {},
    })
      .then(response => {
        const result = response;
        let partnersData = result?.data || [];

        // Apply search filter for both regular and recycled data
        if (formData?.title && formData.title.length > 0) {
          partnersData = partnersData.filter(item =>
            (item.user_username && item.user_username.toLowerCase().includes(formData.title.toLowerCase())) ||
            (item.user_email && item.user_email.toLowerCase().includes(formData.title.toLowerCase())) ||
            (item.user_mobile && item.user_mobile.toLowerCase().includes(formData.title.toLowerCase()))
          );
        }

        // The partner `index` endpoint merges user data. Transform for display.
        const updatedList = partnersData.map((item) => {
          const statusText = item?.status === 1 ? "Active" : item?.status === 0 ? "Pending" : "In-Active";
          return {
            ...item, // includes partner and user data
            id: item.id, // Partner ID
            username: item.user_username || 'N/A',
            email: item.user_email || 'N/A',
            mobile: item.user_mobile || 'N/A',
            role: 'Partner',
            active: statusText,
            user_avatar: item.user_user_avatar || '/default-avatar.png',
            upload_on: item.createdAt,
            commission_percentage: item.commission_percentage || 0
          };
        });

        // Calculate analytics for partners
        const totalPartners = updatedList.length;
        const activePartners = updatedList.filter(p => p.status === 1).length;
        const pendingPartners = updatedList.filter(p => p.status === 0).length;
        const totalCommission = totalPartners > 0
          ? (updatedList.reduce((sum, p) => sum + (Number(p.commission_percentage) || 0), 0) / totalPartners)
          : 0;

        setAnalytics({
          totalPartners,
          activePartners,
          pendingPartners,
          totalCommission: totalCommission.toFixed(2)
        });

        // Implement client-side pagination as partner API returns all data
        const totalItems = updatedList.length;
        const totalPages = Math.ceil(totalItems / limit);
        const startIndex = (page - 1) * limit;
        const paginatedData = updatedList.slice(startIndex, startIndex + limit);

        setApiData(paginatedData);
        setTotal({
          totalItems,
          totalPages,
          currentPage: page,
          count_all: totalItems,
          itemsPerPage: limit // Add this missing property for AdminTable pagination display
        });

        setLoading(false);
      })
      .catch(error => {
        console.error('Fetch error:', error);
        toast.error(error?.response?.data?.message || error?.message)
        setLoading(false);
      })
  };

  const fetchAllData = async (type, find) => {
    // Use the correct API based on current view (draft/recycle or normal)
    const exportApiUrl = draft === 1 ? recycleApi : listApi;
    const data = await fetchRequest({
      method: 'GET',
      url: exportApiUrl,
      params: draft === 0 ? {
        search: find === "ALL" ? null : formData?.title,
        page: 1,
        limit: find === "ALL" ? 9999 : 9999, // Get all for export
      } : {},
      data: {},
    });

    let partnersData = data?.data || [];
    let updatedList;

    if (find === "ALL") {
      updatedList = partnersData.map((item) => ({
        ...item,
        id: item.id,
        username: item.user_username || 'N/A',
        email: item.user_email || 'N/A',
        mobile: item.user_mobile || 'N/A',
        role: 'Partner',
        active: item?.status === 1 ? "Active" : item?.status === 0 ? "Pending" : "In-Active",
      }));
    } else {
      if (!itemToDelete || itemToDelete.length === 0) {
        alert("Please select at least one row to export.");
        return;
      }
      const transformedData = partnersData.map((item) => ({
        ...item,
        id: item.id,
        username: item.user_username || 'N/A',
        email: item.user_email || 'N/A',
        mobile: item.user_mobile || 'N/A',
        role: 'Partner',
        active: item?.status === 1 ? "Active" : item?.status === 0 ? "Pending" : "In-Active",
      }));
      updatedList = transformedData.filter(item => itemToDelete.includes(item?.id));
      if (!updatedList || updatedList.length === 0) {
        alert("Selected data not found.");
        return;
      }
    }

    const exportData = updatedList.map((item, index) => ({
      "S.NO": index + 1,
      "ID": item?.id,
      "USERNAME": item?.username,
      "E-MAIL": item?.email,
      "ROLE": item?.role,
      "MOBILE": item?.mobile,
      "COMMISSION %": item?.commission_percentage || 0,
      "STATUS": item?.active,
      "BANK NAME": item?.bank_name || 'N/A',
      "ACCOUNT NUMBER": item?.account_number || 'N/A'
    }));

    const exportColumns = ["S.NO", "ID", "USERNAME", "E-MAIL", "ROLE", "MOBILE", "COMMISSION %", "STATUS", "BANK NAME", "ACCOUNT NUMBER"];

    if (type === "CSV") {
      await donwloadCSV(exportData, "PARTNER-LIST");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "PARTNER-LIST", exportColumns);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "PARTNER-LIST", exportColumns);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);

    try {
      let response;

      // action: 3 is for restore/undo
      if (deleteActionType === 3) {
        response = await fetchRequest({
          method: 'POST',
          url: restoreApi,
          data: { partnerIds: itemToDelete }
        });
      } else { // action: 1 for permanent, 2 for soft delete
        // The controller uses `multiDelete` for multiple IDs and `delete` for single ID.
        // But the `multiDelete` can handle one, let's check `AdminPartnerController.js` again.
        // `multiDelete` expects `partner_ids` array. `delete` expects `id`.
        // The logic here is for multiple delete. So it's `multiDeleteApi`
        response = await fetchRequest({
          method: 'POST',
          url: multiDeleteApi,
          data: {
            partner_ids: itemToDelete,
            // action: 1 is hard delete, 0 is soft delete in controller, but here its 1 and 2.
            // deleteActionType: 1 is permanent, 2 is soft. Controller wants 1 (hard) and 0 (soft).
            action: deleteActionType === 1 ? 1 : 0
          }
        });
      }

      const result = response;
      if (result?.status) {
        toast.success(result?.message);
        setItemToDelete([]);
        closeModal();
      } else {
        toast.error(result?.message);
      }

    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setShowOverlay(false);
      setWithoutRefresh(!withOutRefresh);
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleSizePerPageChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([])
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    if (draft === 1) {
      setDeleteActionType(3)
      setPermanent(0)
    }
  };

  const singlePeramanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setPermanent(1)
    setDeleteActionType(1)
  }

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  const partnerFormatter = (data, row) => { // Renamed formatter
    return (
      <div className="d-flex justify-content-between gap-3 align-items-center">
        <img
          style={{ height: "40px" }}
          key={row?.user_avatar}
          src={`${row.user_avatar}?v=${row.upload_on ? new Date(row.upload_on).getTime() : Date.now()}`}
          alt="Avatar"
          className="userProfileImageSize rounded-circle object-fit-cover"
          onError={(e) => { e.target.src = '/default-avatar.png'; }} // Fallback image
        />
        <div className="rightUserTitle">
          <p className="userNameProfile text-break">{data}</p>
          <span className="userDateText">{moment(row?.upload_on).format('MMMM Do YYYY')}</span>
          <small className="text-muted d-block">Commission: {row?.commission_percentage || 0}%</small>
        </div>
      </div>
    );
  };

  const columns = [
    {
      dataField: "username",
      text: "Partners", // Changed text
      formatter: partnerFormatter, // Use new formatter
      sort: true,
      classes: "userDesignBox",
      headerClasses: "userDesignBox"
    },
    {
      dataField: "mobile",
      text: "Contact",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <span className="text-break  d-flex align-items-center justify-content-center w-100">{cell}</span>
      }
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      headerClasses: "userEmailBox"
    },
    {
      dataField: "commission_percentage",
      text: "Commission",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center w-100">
            <span className="badge bg-info text-dark">{cell || 0}%</span>
          </div>
        )
      }
    },
    {
      dataField: "active",
      text: "Status",
      sort: true,
      formatter: (cell, row) => statusActiveFormatteruser(cell, row),
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <div className="editdropdown"
        onClick={() => setActiveId(row.id)}
        onMouseLeave={() => setActiveId(null)}
        id={`moreOption`}>
        <span className="editdropdown-button">
          <FaEllipsisVertical />
        </span>
        <div className={`editdropdown-menu theme-bg-color ${activeId == row?.id ? "d-block" : "d-none"}  ${formData?.view_type}`}>
          {draft !== 1 && <Link id={`Edit `} to={`${"/edit-partner/"}${row?.id}`} className="theme-text-color  theme-bg-color">
            <span className="theme-text-color">
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>}
          <div id={`deleteButton`} onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
            {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
            <MessageBox text={`${draft == 1 ? "undo" : "Delete"}`} classname='ms-2 theme-text-color'></MessageBox>
          </div>
          {draft == 1 && (<div id={`permanentDeleteButton`} onClick={() => singlePeramanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
            <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
            <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color'></MessageBox>
          </div>)}
        </div>
      </div >
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
    sizePerPageList: [
      { text: '5', value: 5, id: "optionOne" },
      { text: '10', value: 10, id: "optionTwo" },
      { text: 'All', value: total?.totalItems, id: "optionThree" }
    ]
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };

  const reloadAction = () => {
    setDraft(0)
    setWithoutRefresh(prev => !prev)
    setApiData([])
    setItemToDelete([]) // Clear selected checkboxes on refresh
    setAnalytics({ // Reset partner analytics
      totalPartners: 0,
      activePartners: 0,
      pendingPartners: 0,
      totalCommission: 0
    })
  }

  const reCycleBin = () => {
    setDraft(prev => prev === 1 ? 0 : 1);
    setItemToDelete([]);
  };

  // Add undo functionality for selected items in recycle bin
  const handleUndoSelected = () => {
    if (itemToDelete.length === 0) {
      toast.error("Please select at least one item to restore.");
      return;
    }
    setDeleteActionType(3); // Set to restore action
    setPermanent(0);
    setModelClose(true); // Open confirmation modal
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, draft]);

  useEffect(() => {
    if (draft === 0) {
      setDeleteActionType(2)
    }
    if (draft === 1) {
      setDeleteActionType(3)
    }
    if (draft === 1 && Permanent == 1) {
      setDeleteActionType(1)
    }
  }, [draft, Permanent])

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal headingText={(draft === 1 && Permanent === 1) ? "Confirm Permanent Deletion" : (draft === 1) ? "Confirm Undo" : "Confirm Delete"} message={(draft === 1 && Permanent === 1) ? "Are you sure you want to permanent delete this items" : (draft === 1) ? "Are you sure you want to undo this items" : "Are you sure you want to delete this items"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={(draft === 1 && Permanent === 1) ? "Delete Permanent" : (draft === 1) ? "Undo" : "Delete"} />}
      <section className="pb-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number">
              <p className="countHead mb-2"> {analytics?.totalPartners}</p>
              <p className="countHead mb-1">Total Partners</p>
              <span className="countDes">The Total Number Of Partners.</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number">
              <p className="countHead mb-2"> {analytics?.activePartners}</p>
              <p className="countHead mb-1">Active Partners</p>
              <span className="countDes">Currently Active Partners.</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number ">
              <p className="countHead mb-2"> {analytics?.pendingPartners}</p>
              <p className="countHead mb-1">Pending Partners</p>
              <span className="countDes">Partners Awaiting Approval</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number ">
              <p className="countHead mb-2">{analytics?.totalCommission}%</p>
              <p className="countHead mb-1">{draft === 1 ? 'Deleted Partners' : 'Avg Commission'}</p>
              <span className="countDes">{draft === 1 ? 'Partners in Recycle Bin' : 'Average Commission Rate'}</span>
            </div>
          </div>
        </div>
      </section>

      {draft === 1 && itemToDelete.length > 0 && (
        <div className="d-flex justify-content-center mb-3">
          <button
            className="btn btn-warning d-flex align-items-center gap-2"
            onClick={handleUndoSelected}
            id="undoSelectedButton"
          >
            <LiaUndoAltSolid style={{ width: "18px", height: "18px" }} />
            <span>Undo Selected ({itemToDelete.length})</span>
          </button>
        </div>
      )}

      <AdminNavbar heading={"All Partners"} totalDataLength={total?.totalItems}
        deleteCount={itemToDelete?.length}
        navigation={"/add-partner"}
        deleteMethod={openModal}
        navText={"Add Partner"} />

      <div className='theme-bg-color p-3 rounded-3 mb-5'>
        <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
          <div className='d-flex align-items-center gap-2'>
            <input type='search' placeholder='Search' name="title" className='rounded-3  theme-border-color border-solid-width border-solid table-search   theme-bg-color-secondary' onChange={handleInput} id='searchInput' />

            {/* Undo and Delete Permanent buttons for recycle bin */}
            {draft === 1 && itemToDelete.length > 0 && (
              <>
                <button
                  className="btn btn-info d-flex align-items-center gap-2 px-3"
                  onClick={handleUndoSelected}
                  id="topUndoButton"
                >
                  <LiaUndoAltSolid style={{ width: "16px", height: "16px" }} />
                  <span>Undo</span>
                </button>
                <button
                  className="btn btn-danger d-flex align-items-center gap-2 px-3"
                  onClick={() => {
                    setDeleteActionType(1);
                    setPermanent(1);
                    setModelClose(true);
                  }}
                  id="topDeletePermanentButton"
                >
                  <MdDelete className="exportIcon me-1" fill="#fff" />
                  <MessageBox text="Delete" classname="admin-button-text" />
                </button>
              </>
            )}
          </div>
          <div className=' d-flex align-items-center'>
            <button className={` reloadButton p-2 me-2 custom-tool-tip-parent  border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin} id='recycleButton'>
              <BiRecycle style={{ width: "18px", height: "15px" }} />
              <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            <button className={`bg-transparent reloadButton custom-tool-tip-parent theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color`} onClick={reloadAction} id='reloadButton'>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                <li className="dropdown-item theme-text-color" id='exportCSV' onClick={() => fetchAllData("CSV")}>CSV</li>
                <li className="dropdown-item theme-text-color" id='exportPDF' onClick={() => fetchAllData("PDF")}>PDF</li>
                <li className="dropdown-item theme-text-color" id='exportXLSX' onClick={() => fetchAllData("XLSX")}>XLSX </li>
              </ul>
            </div>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export all</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                <li className="dropdown-item theme-text-color" id='exportAllCSV' onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                <li className="dropdown-item theme-text-color" id='exportAllPDF' onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                <li className="dropdown-item theme-text-color" id='exportAllXLSX' onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>

        <AdminTable data={apiData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          selectRow={selectRow}
          multiSelect
          onRowSelect={handleRowSelect}
          onSort={handleSort}
          onSelectAll={handleSelectAll}
          viewType={formData?.view_type}
        />
      </div >
    </>
  );
}

export default AllPartners;
